import { render, staticRenderFns } from "./services-page-loader.vue?vue&type=template&id=2af9a25a"
import script from "./services-page-loader.vue?vue&type=script&lang=js"
export * from "./services-page-loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports